<template>
  <div class="app-shell">
    <HeaderComponent />
    <main class="app-main">
      <section class="hero">
        <h1>Lisansüstü Tercih Sihirbazı</h1>
        <p>
          Mezun olduğunuz programı seçin; başvurabileceğiniz yüksek lisans ve
          doktora programlarını koşullarıyla birlikte sizin için listeleyelim.
        </p>
      </section>
      <SearchProgram />
    </main>
    <footer class="app-footer">
      <div class="app-footer__left">
        <span class="app-footer__muted">© {{ currentYear }}</span>
        <a href="https://www.erdogan.edu.tr/" target="_blank" rel="noopener"
          >Recep Tayyip Erdoğan Üniversitesi</a
        >
        <span class="app-footer__sep">·</span>
        <a href="https://bidb.erdogan.edu.tr/" target="_blank" rel="noopener">
          <svg
            class="app-footer__heart"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
            />
          </svg>
          Bilgi İşlem Daire Başkanlığı</a
        >
      </div>
      <div class="app-footer__right">
        <span><strong>Geliştiren:</strong> Öğr. Gör. Uygar Aydin</span>
        <span class="app-footer__sep">·</span>
        <span>
          <strong>Sistem Sorumlusu:</strong>{{ " " }}
          <a
            href="http://lisansustu.erdogan.edu.tr/"
            target="_blank"
            rel="noopener"
            >Lisansüstü Eğitim Enstitüsü</a
          >
        </span>
        <span class="app-footer__note"
          >Sistemin destek ve işletim sorumluluğu Lisansüstü Eğitim Enstitüsüne
          aittir.</span
        >
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import SearchProgram from "@/components/SearchProgram.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComponent,
    SearchProgram,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
<style scoped></style>
